export const editInputAmounts = (savingsInfoArr, currentCash, monthlyIncome, totalSavings) => {
    let totalOneTimeAmt = 0;
    let totalTransferAmt = 0;
    let totalTransferFee = 0;
    let totalMonthlyAmt = 0;
    let totalPrevMonthlyAmt = 0;
    let messageTextArr = [];
    let fieldErrors = false;
    for (let i=0; i<savingsInfoArr.length; i++){
        const savingsInfo = savingsInfoArr[i];
        totalOneTimeAmt += +savingsInfo.oneTimeDepositAmt;
        totalMonthlyAmt += +savingsInfo.monthlyDepositAmt;
        totalTransferAmt += +savingsInfo.newTransferAmt;
        totalTransferFee += +savingsInfo.newTransferFee;
        totalPrevMonthlyAmt += +savingsInfo.currentMonthlyAmt;
    }
    const totalCashChg = totalOneTimeAmt - totalTransferAmt;
    if (+currentCash > 0 && totalCashChg > +currentCash){ 
        fieldErrors = true;
        messageTextArr.push("Total one-time deposit amounts exceed current cash amount.");
    }
    if (+currentCash <= 0 && totalCashChg > 0){
        fieldErrors = true;
        messageTextArr.push("Current cash is lt/eq 0. Total transfer amt must be gt one time deposit amt.")
    }
    if (totalMonthlyAmt > +monthlyIncome){
        fieldErrors = true;
        messageTextArr.push("Total monthly deposit amount exceeds monthly income.");
    }
    if (totalTransferAmt > totalSavings){
        fieldErrors = true;
        messageTextArr.push("Total transfer amount exceeds total amount saved");
    }
    if (totalOneTimeAmt === 0 && totalMonthlyAmt === 0 && totalTransferAmt === 0 && 
        totalPrevMonthlyAmt === 0){
        fieldErrors = true;
        messageTextArr.push("All amounts are zero. Enter amounts or click close.");
    }
    const returnObj={fieldErrors: fieldErrors, messageTextArr: messageTextArr,
        totalOneTimeAmt: totalOneTimeAmt, totalTransferAmt: totalTransferAmt,
        totalTransferFee: totalTransferFee, totalNewMonthlyAmt: totalMonthlyAmt };
    return returnObj;
}

export default editInputAmounts;